<template>
    <div id="app">
        <app-header v-if="$route.path.indexOf('/login') < 0 && $route.path.indexOf('/forgotpassword') && $route.path.indexOf('/resetpassword')"></app-header>
        <div id="wrapper" :class="'app-sidebar-right ' + menuclass">
             <app-menu v-if="$route.path.indexOf('/login') < 0 && $route.path.indexOf('/forgotpassword') && $route.path.indexOf('/resetpassword')"></app-menu>
            <router-view></router-view>
            <!-- <app-footer v-if="$route.path.indexOf('/login') < 0 && $route.path.indexOf('/forgotpassword') && $route.path.indexOf('/resetpassword')"></app-footer> -->
        </div>
    </div>
</template>

<script>
    require("@babel/polyfill");
    import 'core-js/es6/number';
    import FrontHeader from '@/components/partials/FrontHeader';
    import FrontFooter from '@/components/partials/FrontFooter';
    import FrontMenu from '@/components/partials/FrontMenu';
    /*import 'core-js/fn/string/includes';
     import 'core-js/es7/array';*/
    export default {
        name: 'App',
        components: {
            'app-header': FrontHeader,
            'app-footer': FrontFooter,
            'app-menu': FrontMenu,
        },
        data: () => ({
                menuclass: '',
            }),
        mounted: function () {
            var self = this;
            var viewportWidth = $(window).width();
            if (viewportWidth <= 667) {
                if (localStorage.getItem("menu_small") == '1') {
                    $(".app-sidebar-right").removeClass('toggled');
                    $(".app-sidebar-right").removeClass('toggled-2');
                }
            } else {
                if (localStorage.getItem("menu_small") == '1') {
                    $(".app-sidebar-right").removeClass('toggled-2');
                    $(".app-sidebar-right").removeClass('toggled');
                    self.menuclass = 'toggled-2';
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/App.vue